<template>
  <div class="sports_item_detail">
    <Empty description="加载中..." v-if="itemDetail == ''" />
    <div class="body" v-else>
      <mVideo
        :videoUrl="itemDetail.mediaurl"
        v-if="itemDetail.mediaurl"
        height="4rem"
        fit="contain"
      ></mVideo>
      <VanImage :src="itemDetail.icon" style="width: 7.5rem;height:3.75rem;" v-else></VanImage>
      <Panel class="header" :title="itemDetail.title">
        <CellGroup :border="false">
          <Cell title="开始时间" icon="clock-o">
            {{
            itemDetail.start_time
            }}
          </Cell>
          <Cell title="截止时间" icon="clock-o">{{ itemDetail.end_time }}</Cell>
          <Cell
            title="投票开始时间"
            v-if="itemDetail.type == 4 && itemDetail.vote_start_time"
            icon="clock-o"
          >{{ itemDetail.vote_start_time }}</Cell>
          <Cell
            title="投票截止时间"
            v-if="itemDetail.type == 4 && itemDetail.vote_end_time"
            icon="clock-o"
          >{{ itemDetail.vote_end_time }}</Cell>
          <Cell title="联系方式" icon="contact" v-if="itemDetail.contact && itemDetail.contact!=0">
            {{
            itemDetail.contact
            }}
          </Cell>
          <Cell
            title="活动规程"
            icon="todo-list-o"
            is-link
            v-if="itemDetail.rules"
            @click="show = true"
          ></Cell>
        </CellGroup>
      </Panel>

      <Popup v-model="show" closeable position="bottom" :style="{ height: '100%' }">
        <div class="vhtml" v-html="itemDetail.rules"></div>
      </Popup>

      <Panel title="要点" v-if="itemDetail.type != 4">
        <div
          v-html="itemDetail.content"
          class="vhtml"
          style="font-size: 14px;padding:.2rem .3rem .2rem;"
        ></div>
      </Panel>

      <!-- <rank-list v-if="itemDetail.type == 4 && sports_id != 15 " :item_sub_id="item_sub_id" :sports_id="sports_id"></rank-list>
      <CellGroup v-if="itemDetail.type != 4 && +itemDetail.total>0 && +sports_id" title="排行榜">
        <Cell is-link center title-class="join-list-title" @click="goRank">
          <div slot="title">
            {{ itemDetail.total }}
            <span style="font-size:12px;">人</span>
          </div>
          <div slot="label">已完成</div>
          <div v-if="joinList.length" class="joinuser">
            <template v-for="(item, index) in joinList.slice(0, 5)">
              <van-image
                v-if="item.avatarurl"
                :src="item.avatarurl"            
                :style="
                  `transform:translateX(${(joinList.slice(0, 5).length -
                    1 -
                    index) *
                    25}%)`
                "
              />
              <div v-else class="van-image" :style="
                {'transform':'translateX('+((joinList.slice(0, 5).length - 1 - index) * 25) + ')',background:filername(item.nickname)}">
                {{item.nickname.substr(0,1)}}
              </div>
            </template>
            
          </div>
        </Cell>
      </CellGroup> -->
    </div>
    <Footbar>
      <Cell slot="footbar" v-if="itemDetail && itemDetail.register_type == 1">
        <Button
          v-if="itemDetail.today_state !== 1"
          round
          class="mvbutton"
          style="width: 100%;"
          block
          :disabled="itemDetail.disabled"
          :to="{ name: 'joinSports', params: this.$route.params }"
        >{{ itemDetail.tips }}</Button>
        <Button
          v-else
          round
          class="mvbutton"
          style="width: 100%;"
          block
          :to="{ name: 'sportsResult', params: this.$route.params }"
        >参赛详情</Button>
      </Cell>

      <Cell slot="footbar" v-else>
        <Button
          v-if="itemDetail.register_type == 2"
          round
          class="mvbutton"
          style="width: 100%;"
          block
          :url="itemDetail.register_type_value"
        >立即参与</Button>
        <Button
          v-if="itemDetail.register_type == 3"
          round
          class="mvbutton"
          style="width: 100%;"
          block
          @click="openImg(itemDetail.register_type_value)"
        >立即参与</Button>
        <!-- <Button
          v-if="itemDetail.register_type == 4"
          round
          type="primary"
          block
          :color="buttonColor"
          @click="jumpMp(itemDetail.register_type_value)"
        >立即参与</Button> -->
      </Cell>
    </Footbar>
    <van-dialog v-if="itemDetail.register_type == 3" v-model="show" title="长按跳转">
      <div class="img-area">
        <img :src="itemDetail.register_type_value" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import moment from "moment";
import mVideo from "@/components/mVideo/index";
import Footbar from "@/components/footbar/index";
import rankList from "./rank";
import { Empty, Panel, Cell, Button, CellGroup, Image, Popup } from "vant";
import "./index.less";
import imgurl from "@/assets/img/common/default.png";
import util from 'libs/utils';
import { mapGetters, mapMutations } from "vuex";
export default {
  computed: {
    // ...mapGetters(["getOnlyUserInfo"]),
    imgurl() {
      return imgurl;
    },
    buttonColor() {
      let detail = this.detail;
      if (!detail) return "#ccc";
      return `${detail.tabstyle[0]["color"]}`;
    },
  },
  filters: {
    
  },
  components: {
    mVideo,
    Empty,
    Panel,
    Cell,
    Button,
    CellGroup,
    Footbar,
    VanImage: Image,
    rankList,
    Popup,
  },
  data() {
    return {
      show: false,
      detail: "",
      itemDetail: "",
      joinList: [],
      sports_id: '',
      item_sub_id: ''
    };
  },
  methods: {
    ...mapMutations(["toggleShowFill"]),
    filername(name){
      let val = util.hc(name,6)
      console.log(val)
      switch(val*1){
        case 0:
          return '#B9C5D1';
        case 1:
          return '#D2C1B9';
        case 2:
          return '#BAB3C6';
        case 3:
          return '#D3BFC8';
        case 4:
          return '#D0CAB2';
        case 5:
          return '#B6C3B2';
      }
    },
    goRank() {
      // :to=""
      this.$router.push({ name: "sportsRank", params: this.$route.params, query: {rank_type: this.itemDetail.rank_type} });
    },
    // jumpMp(value) {
    //   let jump = {
    //     appId: value
    //   }
    //   value = Base64.encodeURI(JSON.stringify(jump));
    //   //跳转小程序 webview无法直接跳转外部小程序 需要通过当前小程序中转
    //   wx.miniProgram.navigateTo({
    //     url: `/pages/jumpmp/index?jumpinfo=${value}`,
    //   });
    // },
    openImg(url) {
      wx.previewImage({
        current: "", // 当前显示图片的http链接
        urls: [url], // 需要预览的图片http链接列表
      });
    },
    init: function () {
      this.$toast.loading({
        duration: 0,
      });
      let params = { cpgid: this.item_sub_id };
      Promise.all([
        this.$api.sports.sportsMain({sports_id:this.sports_id}),
        this.$api.mwap.getComparegame(params),
      ]).then(
        (res) => {
          let { bgstyle, id, tabstyle, introstyle, title } = res[0].data;
          try {
            bgstyle = JSON.parse(bgstyle);
            tabstyle = JSON.parse(tabstyle);
            introstyle = JSON.parse(introstyle);
          } catch (e) {
            console.error(e);
          }
          this.detail = { id, bgstyle, tabstyle, introstyle, title };
          this.joinList = Object.assign([], res[1]["data"]["list"]);
          delete res[1]["data"]["list"];
          let { start_time, end_time, sex_limit, age_limit } = res[1]["data"];
          start_time = moment(start_time).valueOf();
          end_time = moment(end_time).valueOf();
          var sys_time = res[1]["sys_time"] * 1000;
          let tips,
            disabled = true;
          if (sys_time < start_time) {
            tips = "活动未开始";
          } else if (sys_time > end_time) {
            tips = "活动已结束";
          } else {
            tips = "立即参与";
            disabled = false;
          }
          this.itemDetail = Object.assign(res[1]["data"], { tips, disabled });
          this.$toast.clear();
          //判断 是否需要 限制性别 或生日 如果需要则要填写信息
        //   if (+sex_limit !== 0 || +age_limit !== 0) {
        //     let { name, phone, id_number, gid } = this.getOnlyUserInfo;

        //     if (!!name && !!phone && !!id_number) {
        //     } else {
        //       //需要补全信息
        //       this.toggleShowFill(true);
        //       return;
        //     }
        //   }
        },
        () => {
          this.$toast.clear();
        }
      );
    },
  },
  mounted() {
    this.item_sub_id = this.$route.params.item_sub_id
    this.sports_id = this.$route.params.sports_id
    this.init();
    this.cf.wxShareConf();
  },
};
</script>

<style scoped>
.html >>> img {
  max-width: 100%;
}

.img-area {
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-area img {
  max-width: 100%;
}
</style>
